const overrides = new Map<string, [number, number]>();

export function setDrawOverride(id: string, coords: [number, number]) {
	overrides.set(id, coords);
}

export function clearDrawOverrides() {
	overrides.clear();
}

export function getDrawOverrides(): ReadonlyMap<string, [number, number]> {
	return overrides;
}
